import { createUrl } from './utils/createUrl';
import {
    Onboarding,
    NotFound,
    ProfileAdminPage,
    ProfileView,
    AllProfiles,
} from './pages';

export default function getRoutes() {
    return [
        {
            path: createUrl('/onboarding'),
            component: Onboarding,
        },
        {
            path: createUrl('/(bedrift/)?company/:id/:sub'),
            component: ProfileAdminPage,
        },
        {
            path: createUrl('/company/:id'),
            component: ProfileView,
        },
        {
            path: createUrl('/companies/:page?'),
            component: AllProfiles,
        },
        {
            path: createUrl('*'),
            component: NotFound,
        },
    ];
}
